import type { Entity } from "../index"
import type { HasEntityFloorElevation } from "./HasEntityFloorElevation.type"

export default function isEntityHasFloorElevation(
  entity: Entity
): entity is Entity & HasEntityFloorElevation {
  return 'floor_e' in entity
}
